@layer module {
.file-upload-wrapper {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: space-between;
    }

.file-upload-container {
            display: flex;
            align-items: center;
    }

.uploaded-filename {
            display: flex;
            flex-flow: column nowrap;
    }

.uploaded-filename .label {
            word-wrap: break-word;
    }

.uploaded-filename .filename {
            white-space: normal;
            word-break: break-all;
            overflow-wrap: anywhere;
    }

.uploaded-file-delete {
            cursor: pointer;
    }

.upload-component-wrapper {
            cursor: pointer;
            border-width: 1px;
            border-style: dashed;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;
            text-align: center;
    }

.upload-component-wrapper div {
            display: flex;
            flex-flow: column nowrap;
    }

.upload-component-wrapper.disabled {
            opacity: 0.5;
            cursor: not-allowed;
    }
} // layer module










@layer app {
.file-upload-wrapper {
            gap: $size-10;
            height: $size-63;
            border-radius: $size-8;
            min-height: $size-120;
            padding: $size-16 $size-25;
    }

.uploaded-filename {
            margin-left: $size-5;
    }

.upload-component-wrapper {
            min-height: $size-120;
            padding: 0 $size-20;
            border-radius: $size-5;
            gap: $size-20;
    }

.upload-component-wrapper span {
            margin-bottom: $size-5;
    }

.upload-component-format {
            margin-top: $size-8;
    }

.file-upload-wrapper {
            border: 1px dashed var(--file-upload-active-border);
            background-color: var(--file-upload-active-background);
    }

.upload-component-wrapper.disabled svg path {
            stroke: var(--file-upload-action);
    }

.file-upload-container {
            font-size: var(--font-size-sm);
            font-style: normal;
            font-weight: 400;
            line-height: $size-15;
    }

.uploaded-filename .label {
            color: var(--file-upload-success);
    }

.uploaded-filename .filename {
            color: var(--custom-selector-icon-placeholder-bg);
    }

.upload-component-wrapper {
            background-color: var(--file-upload-file-background);
            border-color: var(--file-upload-border);
            color: var(--custom-selector-content);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

.upload-component-wrapper .or {
            color: var(--file-upload-action);
    }

.upload-component-wrapper.disabled {
            background-color: var(--file-upload-file-background);
    }

.upload-component-format {
            color: var(--custom-selector-control-text);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }
} // layer app
